var _a, _b;
const config = {
    // Use runtime config if available (Docker), otherwise build-time env var, otherwise default
    backendUrl: ((_a = window.__ENV__) === null || _a === void 0 ? void 0 : _a.BACKEND_URL) || ((_b = import.meta.env) === null || _b === void 0 ? void 0 : _b.VITE_BACKEND_URL) || 'http://localhost:8000',
};
export default config;
